import Checkbox from "@mui/material/Checkbox";
import { Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { Card, Col, Collapse, Container, Image, Row } from "react-bootstrap";
import JobsCard from "../Components/JobsCard";
import jobs1 from "../assets/images/jobs1.png";
import jobsIcon1 from "../assets/images/jobsIcon1.png";
import jobsIcon2 from "../assets/images/jobsIcon2.png";
import jobLogo from "../assets/images/jobLogo.png";
import { Link, useHistory } from "react-router-dom";
import jobsIcon3 from "../assets/images/jobsIcon3.png";
import { Get, Post } from "../Axios/AxiosFunctions";
import { apiHeader, imageUrl, URL, recordsLimit } from "../Config/apiUrl";
import { useSelector } from "react-redux";
import PaginationB from "../Components/PaginationB";
import ForCompFace from "../assets/images/ForCompFace.png";
import forCompLoc from "../assets/images/forCompLoc.png";
import NullData from "./../Components/NullData";

const AllJobs = ({ setfooterStyle }) => {
  const user = useSelector((state) => state?.authReducer?.user);
  const history = useHistory();
  const [page, setPage] = React.useState(1);
  const handleChangePagination = (event, value) => {
    setPage(value);
  };
  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  const token = useSelector((state) => state?.authReducer?.access_token);

  const [openLocation, setOpenLocation] = useState(true);
  const [openFields, setOpenFields] = useState(true);
  const [openCertificate, setOpenCertificate] = useState(true);
  const [openEducation, setOpenEducation] = useState(true);
  const [openSkills, setOpenSkills] = useState(true);
  const [openTypeOfJob, setOpenTypeOfJob] = useState(true);
  const [openTimeHorizon, setOpenTimeHorizon] = useState(true);
  const [checked, setChecked] = React.useState({
    closeToYou: false,
    blackSmith: false,
    welder: false,
    carpenter: false,
    blackSmith1: false,
    welder1: false,
    carpenter1: false,
    drivingLicense: false,
    tryAndHire: false,
    directHire: false,
    subsitude: false,
    oneMonth: false,
    threeMonth: false,
    sixMonth: false,
  });

  const [selectedCertificate, setSelectedCertificate] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState([]);

  // filter states
  const [responseData, setResponseData] = useState([]);
  const [skills, setSkills] = useState([]);
  const [certificate, setCertificate] = useState([]);
  const [coursesNewArray, setCoursesNewArray] = useState([]);
  const [educationNewArray, setEducationNewArray] = useState([]);
  const [experienceNewArray, setExperienceNewArray] = useState([]);
  const [course, setCourse] = useState([]);
  const [education, setEducation] = useState([]);
  const [experience, setExperience] = useState([]);

  const [searchArray, setSearchArray] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // data
  const [jobsData, setJobsData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [isLoadingJobs, setIsLoadingJobs] = useState(false);

  const header = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  const location = [{ name: "Close to you" }];
  const typeOfJob = [
    {
      name: "Try and hire",
    },
    {
      name: "Direct hire",
    },
    {
      name: "Hire directly",
    },
  ];
  const timeHorizon = [
    { name: "Fixed" },
    { name: "Time Limited" },
    { name: "4 Weeks" },
    { name: "8 Weeks" },
    { name: "12 Weeks" },
  ];
  const skillsArray = [];
  const certifcateArray = [];
  const educationArray = [];
  const coursesArray = [];
  const experienceArray = [];
  const locationArray = [];

  // handleChange
  const handleChange = async (event, arrayName) => {
    const { name, checked } = event.target;
    console.log(name, checked);

    const index = arrayName.findIndex((x) => x == name);
    if (checked) {
      arrayName.push(name);
    } else {
      arrayName.splice(index, 1);
    }
    let data = [
      ...skillsArray,
      ...certifcateArray,
      ...educationArray,
      ...coursesArray,
      ...experienceArray,
    ];

    setSearchArray(data);

    getJobs(data);
  };

  // get listings
  const getJobs = async (filters = []) => {
    const url = URL(`job/searchByFilters?page=${page}&limit=${recordsLimit}`);
    const params = {
      searchArr: filters,
      search: searchTerm,
      userId: user?.UserId?._id,
      role: token ? user?.UserId?.role : "user",
    };

    setIsLoadingJobs(true);
    const response = await Post(url, params, apiHeader());
    setIsLoadingJobs(false);
    if (response !== undefined) {
      setJobsData(response?.data?.data);
      setTotalCount(response?.data?.totalCount);
    }
  };

  // getFilters
  const getFilters = async () => {
    const url = URL(`admin/get-all-array`);
    const response = await Get(url);
    if (response !== undefined) {
      let _updatedCertificates = response?.data?.data?.certificates?.map(
        (cert) => cert?.jobCertificate
      );
      setResponseData(response?.data?.data);
      setSkills(response?.data?.data?.skills);
      setCertificate(response?.data?.data?.certificates);
      setCourse(response?.data?.data?.courses);
      setEducation(response?.data?.data?.educations);
      setExperience(response?.data?.data?.experience);
      const newCourses = [];
      const newEducation = [];
      const newExperience = [];

      response?.data?.data?.courses.map((t) => {
        newCourses.push({ courses: t });
      });
      response?.data?.data?.educations.map((t) => {
        newEducation.push({ educations: t });
      });
      response?.data?.data?.experience.map((t) => {
        newExperience.push({ experience: t });
      });

      setCoursesNewArray(newCourses);
      setEducationNewArray(newEducation);
      setExperienceNewArray(newExperience);
    }
  };

  useEffect(() => {
    getJobs();
  }, [page]);

  useEffect(() => {
    getFilters();
  }, []);

  const count = new Array(9).fill("");

  return (
    <div>
      <div className="allJobs_banner">
        <Container>
          <Row>
            <Col>
              <h2 className="whito">
                {/* craftman */}
                {token && user?.UserId?.role !== "company" && (
                  <>
                    <span className="regular">Search for a job </span> The Job
                    You Are <br />
                    Looking For
                  </>
                )}
                {/* company */}
                {token && user?.UserId?.role === "company" && (
                  <>
                    <span className="regular">The craftman</span>
                    You Are <br />
                    Looking For
                  </>
                )}
                {/* fallback */}
                {!token && (
                  <>
                    <span className="regular">Search for a job </span> The Job
                    You Are <br />
                    Looking For
                  </>
                )}
              </h2>
              <div className="searchField_main">
                <input
                  placeholder="Search..."
                  className="searchField_allJobs"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e?.target?.value);
                  }}
                  onKeyDown={(E) =>
                    E?.code == "Enter" && getJobs(searchArray, searchTerm)
                  }
                />
                <i
                  class="fas fa-search c-p"
                  onClick={() => getJobs(searchArray, searchTerm)}
                ></i>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row>
          <Col xl={2} lg={3} md={4} sm={12}>
            <div className="filter_main">
              <h5 className="border_filter">Filters</h5>
              {/* Location */}
              {/* <div className="dropdown_main Location">
                <div className="d-flex location">
                  <h6>Location</h6>

                  <i
                    onClick={() => setOpenLocation(!openLocation)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openLocation}
                    class={openLocation ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openLocation}>
                  <div id="example-collapse-text">
                    {location.map((item) => (
                      <div className="">
                        <Checkbox
                          // checked={checked.closeToYou}
                          name={item.name}
                          onChange={(e) => handleChange(e, locationArray)}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                        {item.name}
                      </div>
                    ))}
                  </div>
                </Collapse>
              </div> */}
              {/* Skills */}
              <div className="dropdown_main Fields">
                <div className="d-flex fields">
                  <h6>Skills</h6>

                  <i
                    onClick={() => setOpenFields(!openFields)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openFields}
                    class={openFields ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openFields}>
                  <div id="example-collapse-text">
                    {skills?.map((item) => {
                      return (
                        <div className="">
                          <Checkbox
                            // checked={checked.blackSmith}
                            name={item.skill}
                            onChange={(e) => handleChange(e, skillsArray)}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          {item.skill}
                        </div>
                      );
                    })}
                  </div>
                </Collapse>
              </div>

              {/* Certificates */}
              <div className="dropdown_main Certificates">
                <div className="d-flex certificate">
                  <h6>Certificates</h6>
                  <i
                    onClick={() => setOpenCertificate(!openCertificate)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openCertificate}
                    class={openCertificate ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openCertificate}>
                  <div id="example-collapse-text">
                    {certificate?.map((item) => {
                      return (
                        <div>
                          <Checkbox
                            // checked={checked.closeToYou}
                            name={item.jobCertificate}
                            onChange={(e) => handleChange(e, certifcateArray)}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          {item.jobCertificate}
                        </div>
                      );
                    })}
                  </div>
                </Collapse>
              </div>

              {/* educations */}
              <div className="dropdown_main Certificates">
                <div className="d-flex certificate">
                  <h6>Education</h6>
                  <i
                    onClick={() => setOpenEducation(!openEducation)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openEducation}
                    class={openEducation ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openEducation}>
                  <div id="example-collapse-text">
                    {education?.map((item) => {
                      return (
                        <div>
                          <Checkbox
                            // checked={checked.closeToYou}
                            name={item}
                            onChange={(e) => handleChange(e, educationArray)}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          {item}
                        </div>
                      );
                    })}
                  </div>
                </Collapse>
              </div>

              {/* Cources */}
              <div className="dropdown_main Type of Job">
                <div className="d-flex typeOfJob">
                  <h6>Courses</h6>

                  <i
                    onClick={() => setOpenTypeOfJob(!openTypeOfJob)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openTypeOfJob}
                    class={openTypeOfJob ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openTypeOfJob}>
                  <div id="example-collapse-text">
                    {course.map((item) => (
                      <div className="">
                        <Checkbox
                          // checked={checked.tryAndHire}
                          name={item}
                          onChange={(e) => {
                            handleChange(e, coursesArray);
                          }}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                        {item}
                      </div>
                    ))}
                  </div>
                </Collapse>
              </div>

              {/*  Experience */}
              <div className="dropdown_main Time Horizon">
                <div className="d-flex TimeHorizon">
                  <h6>Experience</h6>

                  <i
                    onClick={() => setOpenTimeHorizon(!openTimeHorizon)}
                    aria-controls="example-collapse-text"
                    aria-expanded={openTimeHorizon}
                    class={openTimeHorizon ? "fas fa-minus" : "fas fa-plus"}
                  ></i>
                </div>

                <Collapse in={openTimeHorizon}>
                  <div id="example-collapse-text">
                    {experience.map((item) => (
                      <div className="">
                        <Checkbox
                          // checked={checked.oneMonth}
                          name={item}
                          onChange={(e) => handleChange(e, experienceArray)}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                        {item}
                      </div>
                    ))}
                  </div>
                </Collapse>
              </div>
            </div>
          </Col>

          <Col xl={10} lg={9} md={8} sm={12}>
            <h3>
              {user?.UserId?.role == "company"
                ? "Craftmen For You"
                : "Jobs For You"}
            </h3>
            {/* <JobsCard showArrows={false} enableAutoPlay={true} /> */}
            <Row style={{ margin: 10 }} className="company-jobs-container">
              {/* <Col lg={4} md={4}> */}

              {(user?.UserId?.role != "company" || !token) &&
                jobsData.map((item, i) => {
                  console.log(
                    `${item?.companyId}`,
                    "------------------------------------------------------"
                  );

                  return (
                      <JobsCard data={item}
                      cusClass={"col-xl-4 col-lg-6 col-sm-12"}
                      col={12}
                      key={item?._id} className="w-100" />
                  );
                })}

              {user?.UserId?.role == "company" &&
                jobsData.map((item, i) => {
                  return (
                    <Col lg={4} md={4}>
                      <Card
                        key={i}
                        className="for_comp_main text-center home_card2 home_card_main"
                        onClick={() => {
                          history.push("/ctaftman-profile?id=" + item?._id);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="company-img-box">
                          <Card.Img
                            className="for_comp_main_img"
                            src={`${imageUrl}${item?.photo}`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = ForCompFace;
                            }}
                          />
                        </div>
                        <Card.Body className="alljob-cards">
                          <Card.Title className="text-center font-22">
                            {item?.userName}
                          </Card.Title>
                          <Card.Text>{item?.education}</Card.Text>
                          <Card.Text>
                            <div className="jobData-para">
                              <Image src={forCompLoc} />{item?.address}
                            </div>
                          </Card.Text>

                          <div className="for_comp_tags">
                            {item?.skills.slice(0, 3)?.map((e, i) => (
                              <h6 key={i}>{e}</h6>
                            ))}
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })}

              {isLoadingJobs && <NullData />}
              {!isLoadingJobs && jobsData.length === 0 && (
                <>
                  <p>No data found</p>
                  <Button onClick={() => window.location.reload()}>
                    Reset to Original
                  </Button>
                </>
              )}
              {/* </Col> */}
            </Row>
          </Col>
        </Row>
      </Container>
      <PaginationB page={page} setPage={setPage} totalCount={totalCount} />
    </div>
  );
};

export default AllJobs;

const TypeOfJob = [];
const TimeHorizon = [];
const Fields = [];
const Location = [];
